import { render, staticRenderFns } from "./ProcessException.vue?vue&type=template&id=20060596&scoped=true"
import script from "./ProcessException.vue?vue&type=script&lang=js"
export * from "./ProcessException.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20060596",
  null
  
)

export default component.exports